import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
 
const AdminScore = () => {
  const [scores, setScore] = useState([]);
 
  useEffect(() => {
    getScores();
  }, []);
 
  const getScores = async () => {
    const response = await axios.get("https://livesoc.smakone.org/Scores");
    setScore(response.data);
  };
 
  const deleteScore = async (id) => {
    try {
      await axios.delete(`https://livesoc.smakone.org/Scores/${id}`);
      getScores();
    } catch (error) {
      console.log(error);
    }
  };
 
  return (
    <div className="font-[JakartaSansBold] text-black mt-5">
      <div className="column is-half">
        <Link to={`add`} className="m-10 focus:outline-none text-white bg-yellow-400 hover:bg-yellow-500 focus:ring-4 focus:ring-yellow-300 font-medium rounded-lg px-5 py-2.5 mr-2 mb-2 dark:focus:ring-yellow-900 text-5xl is-success">
          Add New
        </Link>
        <table className="m-10 table is-striped is-fullwidth items-center ">
          <thead>
            <tr className="border">
              <th className="border">No</th>
              <th className="border">Competition</th>
              <th className="border">Day</th>
              <th className="border">Team1</th>
              <th className="border">Team2</th>
              <th className="border">Score1</th>
              <th className="border">Score2</th>
              <th className="border">Quarter1<br/> of T1</th>
              <th className="border">Quarter1<br/> of T2</th>
              <th className="border">Quarter2 <br/>of T1</th>
              <th className="border">Quarter2<br/> of T2</th>
              <th className="border">Quarter3 <br/>of T1</th>
              <th className="border">Quarter3 <br/> of T2</th>
              <th className="border">Quarter4 <br/>of T1</th>
              <th className="border">Quarter4<br/> of T2</th>

            </tr>
          </thead>
          <tbody>
            {scores.map((Score, index) => (
              <tr className='text-2xl' key={Score.id}>
                <td className="border text-center">{index + 1}</td>
                <td className="border text-center">{Score.compe}</td>
                <td className="border text-center">{Score.day}</td>
                <td className="border text-center">{Score.team1}</td>
                <td className="border text-center">{Score.team2}</td>
                <td className="border text-center">{Score.score1}</td>
                <td className="border text-center">{Score.score2}</td>
                <td className="border text-center">{Score.quarter11}</td>
                <td className="border text-center">{Score.quarter12}</td>
                <td className="border text-center">{Score.quarter21}</td>
                <td className="border text-center">{Score.quarter22}</td>
                <td className="border text-center">{Score.quarter31}</td>
                <td className="border text-center">{Score.quarter32}</td>
                <td className="border text-center">{Score.quarter41}</td>
                <td className="border text-center">{Score.quarter42}</td>

                <td className="border">
                  <Link 
                    to={`edit/${Score.id}`}
                    className="border m-2 focus:outline-none text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                  >
                    Edit
                  </Link>
                  <button
                    onClick={() => deleteScore(Score.id)}
                    className="border m-2 focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
 
export default AdminScore;